export class MyController {
  constructor(public $state: ng.ui.IStateService) {}

  isModal(): boolean {
    const views: string[] = this.$state.current ? (this.$state.current as any).views : undefined;

    return views && !_.isEmpty(views['modal@my']);
  }
}

angular.module('capability-ng-user-app').controller('ngMyController', MyController);



// WEBPACK FOOTER //
// ./app/lib/user_app/views/my/my.ts